import { useTranslation } from 'react-i18next';
import { usePendingCount, triggerForceRetry } from '../../hooks/useOfflineSync';
import './PendingBadge.css';

// Badge de operaciones pendientes en cola offline. Equivalente al contador
// que la app Android muestra junto al icono de nube — replica BBDDOfflineRepository
// .getPendingCount(). Al pulsar fuerza un flush con reset de retries —
// recupera incluso items que ya excedían el límite de reintentos.
export function PendingBadge() {
  const { t } = useTranslation();
  const pending = usePendingCount();
  if (pending <= 0) return null;
  return (
    <button
      type="button"
      className="pending-badge"
      onClick={() => triggerForceRetry()}
      aria-label={t('components.pendingBadge', { count: pending })}
      title={t('components.pendingBadgeTitle')}
    >
      <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" aria-hidden="true">
        <path d="M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
      </svg>
      <span className="pending-badge__count">{pending}</span>
    </button>
  );
}
